import { UploadState } from './types';

export const STATE_COLORS: Record<UploadState, 'default' | 'info' | 'warning' | 'success' | 'error'> = {
  accepted: 'info',
  validated: 'info',
  processing: 'warning',
  completed: 'success',
  failed: 'error',
};

export const TERMINAL_STATES: Array<UploadState> = ['completed', 'failed'];

export const POLLING_INTERVAL = 3000;

export const ACCEPTED_FILE_FORMATS =
  '.csv, .xls, .xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
